import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Container, Paragraph, Col} from '@modifi/ui'

import {DefaultComponentWrapper} from '../common'
import {IconTextWrapper} from './styles'

const propTypes = {
  iconList: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ),
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  iconList: [],
  backgroundColor: undefined,
}

export type IconListWithTextProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const IconListWithText: React.FC<IconListWithTextProps> = ({iconList, backgroundColor}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor}>
    <Container>
      <Row justifyContent="around">
        {iconList?.map((iconItem, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Col key={`icon-list-item-${index}`} col="auto">
            <IconTextWrapper>
              <img
                src={iconItem?.icon}
                alt={`icon-list-${iconItem?.description}`}
                height={56}
                width={56}
              />
              <Paragraph my={0}>{iconItem?.description}</Paragraph>
            </IconTextWrapper>
          </Col>
        ))}
      </Row>
    </Container>
  </DefaultComponentWrapper>
)
IconListWithText.propTypes = propTypes

IconListWithText.defaultProps = defaultProps

export default IconListWithText
